import { render, staticRenderFns } from "./index-liuyan.vue?vue&type=template&id=87da8f0e&scoped=true&"
import script from "./index-liuyan.vue?vue&type=script&lang=js&"
export * from "./index-liuyan.vue?vue&type=script&lang=js&"
import style0 from "./index-liuyan.vue?vue&type=style&index=0&id=87da8f0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da8f0e",
  null
  
)

export default component.exports